import {
  ChangeEvent,
  lazy,
  Suspense,
  useContext,
  useEffect,
  useState,
} from "react";
import { useMutation } from "react-query";
import {
  ContextType,
  verificationContext,
} from "../context/VerificationContext";
import {
  Typography,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Box,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import { ActivityType } from "../Types/TableType";
import ErrorIcon from "@mui/icons-material/Error";
import {
  getActivityData,
  // getUploadedDocuments,
  uploadDocuments,
} from "../../services";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import {
  CloudUploadSharp,
  EditNote,
  Image,
  // Visibility,
} from "@mui/icons-material";
import usePopup from "../../../hooks/usePopup";
import { clinicId } from "../../../constants";
import { uploadPayloadType } from "../Types/PayloadType";
import { useLocation, useParams } from "react-router-dom";
import ObservationPopup from "./ObservationPopup";
import { EmrContext } from "../../../EMR/index";
import useAuthentication from "@hooks/useAuthentication";

const Complaints = lazy(
  () => import(`../../../EMR/components/Complaints/Complaints`)
);
const LabComponent = lazy(
  () => import(`../../../EMR/components/Investigation/Lab/LabComponent`)
);
const Radiology = lazy(
  () => import("../../../EMR/components/Investigation/Radiology/Radiology")
);
const Dental = lazy(() => import("../../../EMR/components/DentalProcedures/indexv1"));
const Procedure = lazy(() => import("../../../EMR/components/Procedures"));
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Activity() {
  const [addOpen, setAddOpen] = useState(false);
  const [uploadView, setuploadView] = useState(false);
  const {user} = useAuthentication();
  // const [documentList, setDocumentList] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<ActivityType | null>(null);
  const { encounterId, patientId } = useParams()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { searchData, isDenial, setIsDenial } = useContext(
    verificationContext
  ) as ContextType;
  const {patientData} = useContext(EmrContext);
  const [value, setValue] = useState(0);
  const [obsPayload, setobsPayload] = useState<{
    encounterId: number;
    requestId: number;
    cptGrpId: number;
    postOfficeId: number;
    patientMasterID: number
  } | null>(null);
  const [loadingId, setLoadingId] = useState(-1);
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [tableData, setTableData] = useState<ActivityType[] | any[]>([]);
  const { CustomModal, showSnackbar } = usePopup();

  const { mutate: getallcptData, isLoading: activityLoading } = useMutation(
    getActivityData,
    {
      onSuccess: (data) => {
        const denialstatus = data.response.find((item: any) => {
          return item.denialCode != null ? true : false;
        });
        setIsDenial(denialstatus);
        setTableData(data.response);
      },
    }
  );

  const { mutate: uploadfile, isLoading: uploadLoading } = useMutation(
    uploadDocuments,
    {
      onSuccess: (data) => {
        const message =
          data.responseIndicator === "success"
            ? "Uploaded successfully"
            : "Upload failed";

        const variant =
          data.responseIndicator === "success" ? "success" : "error";

        showSnackbar({
          message,
          open: true,
          duration: 2000,
          variant,
        });
      },
    }
  );

  // const { mutate: getdocuments, isLoading: documentListLoading } = useMutation(
  //   getUploadedDocuments,
  //   {
  //     onSuccess: (data) => {

  //     },
  //   }
  // );

  // const { mutate: viewfile } = useMutation(
  //   viewdocuments,
  //   {
  //     onSuccess: (data) => {
  //        if(data.responseIndicator == "success" && data.response){
  //          printPdf(data.response,"new-tab")
  //        }else{
  //          showSnackbar({
  //             message:data.responseMessage || "Something went wrong1 !",
  //             open:true,
  //             variant:"warning",
  //             duration:4000
  //          })
  //        }
  //     },
  //     onError:(e:any)=>{
  //       showSnackbar({
  //         message:e.response.data.responseMessage || "Something went wrong2 !" ,
  //         open:true,
  //         variant:"warning",
  //         duration:4000
  //      })
  //     }
  //   }
  // );


  // const downloadDocument = (data:ActivityType,index:number) => {

  //   setLoadingId(index);
  //   viewfile({
  //     encounterId:parseInt(encounterId || "0"),
  //     requestId:data?.cptDetails?.requestId || 0,
  //     cptGrpId:data?.cptDetails?.cptGroupId || 0,
  //     postOfficeId:searchData?.patient?.postOfficeId || 0,
  //  })
  // };

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const body: uploadPayloadType = {
        _isEditMode: false,
        _isNew: false,
        _isUpdated: false,
        _isDeleted: false,
        _prevState: false,
        _defaultFieldName: "",
        _userId: 0,
        createdById:Number(user?.userId),
        clinicId,
        encounterId: searchData?.encounter?.encounterId,
        requestId: selectedRow?.cptDetails?.requestId as number,
        groupId: selectedRow?.cptDetails?.cptGroupId || null,
        uploadFlag:Boolean(patientData?.amaster?.uploadFlag) ? 1 : 0
      };
      console.log("patient data inside activity ==> ",patientData)
      // console.log(body);
      uploadfile({ body, file });
    }
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    onFileChange(event);
    event.target.value = "";
  };

  // const [open, setOpen] = useState<boolean>(false);

  // const onSelectActivity = (id: number) => {
  //   setPopUpTab(id);
  //   setOpen(true);
  // };

  // const closeActivity = () => {
  //   getallcptData(searchData?.patient?.encounterID);
  //   setOpen(false);
  // };

  const handleAddModalClose = () => {
    setAddOpen(false)
    if (searchData?.pmaster?.patientId) {
      getallcptData({
        encounterId: searchData?.encounter?.encounterId as number,
        page: queryParams.get("page") || "verification",
      });
    }
  }

  const showpopup = (data: any) => {
    setobsPayload(() => ({
      encounterId: parseInt(encounterId || "0"),
      requestId: data?.cptDetails?.requestId || 0,
      cptGrpId: data?.cptDetails?.cptGroupId || 0,
      postOfficeId: searchData?.postOffice?.postofficeId || 0,
      patientMasterID: parseInt(patientId || "0")
    }))
    setuploadView(true);
  }

  useEffect(() => {
    if (searchData?.pmaster?.patientId) {
      getallcptData({
        encounterId: searchData?.encounter?.encounterId as number,
        page: queryParams.get("page") || "verification",
      });
    }
  }, [searchData?.pmaster?.patientId, getallcptData]);

  return (
    <>
      <CustomModal
        title="Uploaded documents"
        open={uploadView}
        setOpen={setuploadView}
      >
        <Box sx={{ width: "35vw" }}><ObservationPopup data={obsPayload} /></Box>
      </CustomModal>
      <CustomModal title={"Add Activities"} open={addOpen} setOpen={setAddOpen} handleClose={handleAddModalClose}>
        <Box
          sx={{
            width: "85vw",
            height: "85dvh",
            maxHeight: "85dvh",
            overflowY: "auto",
          }}
        >
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              variant="fullWidth"
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              {titlesArray.map((title, index) => (
                <Tab
                  key={`addActivityTitle${index}`}
                  label={title}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <Suspense fallback={<div>Loading Radiology ...</div>}>
              <Radiology />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Suspense fallback={<div>Loading Lab ...</div>}>
              <LabComponent />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Suspense fallback={<div>Loading Complaints ...</div>}>
              <Complaints />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <Suspense fallback={<div>Loading Procedure ...</div>}>
              <Procedure />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <Suspense fallback={<div>Loading Dental Procedure...</div>}>
              <Dental />
            </Suspense>
          </CustomTabPanel>
        </Box>
      </CustomModal>
      <div className="flex justify-between me-5 ">
        <Typography className="!ml-2 !mt-2">
          <strong>Activities</strong>
        </Typography>
        <IconButton
          onClick={() => {
            setAddOpen(true);
          }}
        >
          <EditNote color="primary" />
        </IconButton>
      </div>
      <Divider />
      {tableData.length > 0 ? (
        <TableContainer className="flex flex-col content-between ">
          <Table size="small">
            <TableHead>
              <TableRow>
                {[
                  { label: "Type", alwaysShow: true },
                  { label: "Code", alwaysShow: true },
                  { label: "Description", alwaysShow: true },
                  { label: "Denial Code", condition: isDenial },
                  { label: "Denial Description", condition: isDenial },
                  { label: "Last Submitted", condition: isDenial },
                  { label: "Last Remitted", condition: isDenial },
                  { label: "Last Resubmitted", condition: isDenial },
                  { label: "Activity", alwaysShow: true },
                ]
                  .filter((header) => header.alwaysShow || header.condition)
                  .map((header, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        fontWeight: "bold",
                        backgroundColor: "#f5f5f5",
                        padding: "8px",
                      }}
                    >
                      <strong>{header.label}</strong>
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>
            <CustomTableBody
              isData={tableData?.length > 0}
              dataLoading={activityLoading}
              totalSpan={{ row: 5, col: 4 }}
              alert={"No Records found"}
            >
              {tableData?.map((row: ActivityType, index: number) => (
                <TableRow
                  key={`${row.cptDetails.cptCode}${index}tablebody`}
                  sx={{
                    "&:hover": { backgroundColor: "#f9f9f9" },
                    "&:nth-of-type(even)": { backgroundColor: "#fafafa" },
                  }}
                >
                  <TableCell>{row.cptDetails.cptGroupName}</TableCell>
                  <TableCell>{row.cptDetails.cptCode}</TableCell>
                  <TableCell sx={{ width: "500px" }}>{row.cptDetails.cptDescription}</TableCell>
                  {isDenial && <TableCell>{row?.denialCode}</TableCell>}
                  {isDenial && <TableCell>{row?.denialDescription}</TableCell>}
                  {isDenial && <TableCell>{row?.lastSubmitted}</TableCell>}
                  {isDenial && <TableCell>{row?.lastRemitted}</TableCell>}
                  {isDenial && <TableCell>{row?.lastResubmitted}</TableCell>}

                  <TableCell>
                    {
                      // row?.cptDetails?.cptGroupId==1 || row?.cptDetails?.cptGroupId==2 &&
                      <div>
                        <input
                          hidden
                          type="file"
                          onChange={(event) => {
                            handleFileChange(event);
                          }}
                          id="upload"
                        />
                        <label
                          role="button"
                          htmlFor="upload"
                          onClick={() => {
                            setLoadingId(index);
                            setSelectedRow(row);
                          }}
                        >
                          <CloudUploadSharp color="primary" />
                          {uploadLoading && loadingId == index && (
                            <CircularProgress
                              size={20}
                              color="inherit"
                              style={{ marginLeft: 8 }}
                            />
                          )}
                        </label>
                        {/* {((fileLoading || loading) && loadingId == index) ? <CircularProgress color="primary" size={18} /> : <IconButton onClick={()=>{downloadDocument(row,index)}}>
                          <Image color="primary" />
                        </IconButton>} */}


                        <IconButton onClick={() => { showpopup(row) }}>
                          <Image color="primary" />
                        </IconButton>
                      </div>
                    }
                  </TableCell>
                </TableRow>
              ))}
            </CustomTableBody>
          </Table>
        </TableContainer>
      ) : (
        <div className="col-span-12 flex justify-center items-center flex-col gap-2">
          <ErrorIcon color="info" sx={{ fontSize: "2rem" }} />
          No Activity found
        </div>
      )}
    </>
  );
}

export default Activity;

// const titles = {
//   1: "Radiology",
//   2: "Lab",
//   3: "consultaion",
//   4: "Procedure",
//   5: "Drugs",
//   6: "Dental",
// };

const titlesArray = ["Radiology", "Lab", "consultaion", "Procedure", "Dental"];
